
import React, { useState, useEffect, useRef } from "react";
import GoogleMapReact from 'google-map-react';
import Marker from "./Marker";
import Header from "./Header";
import Card from './Card/Card'; // Assuming path - Please verify
// import Popup from './Card/Popup_v3';
import Popup from './Card/Popup_v4'; // Assuming path - Please verify
import image from '../images/img_map-marker.png'; // Placeholder image path - Please verify
import { AppContainer } from "../App.styles2";
import axios from "axios";
import './HomePage.css'


// Import Slider components
import CustomSlider from "./Slider/CustomSlider";
import CustomSliderFullwidth from "./Slider/CustomSlider-fullwidth"; // Import new full-width slider
import CustomSliderHalfwidth from "./Slider/CustomSlider-halfwidth"; // Import new half-width slider
import CustomSliderThirdwidth from "./Slider/CustomSlider-thirdwidth";

import ReelDisplay from "./Reel/Reel";
import ExpandableCard from "./Reel/ExpandableCard";
import StellerPage from "./Reel/Stell";
import { useParams } from 'react-router-dom';


const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'https://comtruaduytan.com/api/markers/';

const handleGetRecommendations = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${apiBaseUrl}mapMarker/recommendations`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log(response.data);
    alert('Recommendations fetched successfully!');
  } catch (error) {
    console.error('Error getting recommendations:', error);
    alert('Error getting recommendations.');
  }
};

const UserPage = () => {

  const { id } = useParams();
  const defaultProps = {
    center: {
      lat: 21.044175, // Center to San Francisco
      lng: 105.846411,
    },
    zoom: 10,
  };

  const [markers, setMarkers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedHeight, setExpandedHeight] = useState(100); // Use number for comparison, not string

  // Refs for direct DOM manipulation (High Performance Drag)
  const drawerRef = useRef(null);
  const mapRef = useRef(null);
  const dragStartY = useRef(0);
  const dragStartHeight = useRef(0);
  const isDragging = useRef(false);
  const [activeTab, setActiveTab] = useState('posts'); // State for active tab
  const [activeProperty, setActiveProperty] = useState(null); // Added state
  const [showPopup, setShowPopup] = useState(false); // Added state
  const [isFiltering, setIsFiltering] = useState(false); // Added placeholder state
  const [propertiesList, setPropertiesList] = useState([]); // Added placeholder state (initialized empty, will use markers later)
  const [filterIsVisible, setFilterIsVisible] = useState(false); // Added placeholder state
  const [zoomLevel, setZoomLevel] = useState(defaultProps.zoom); // Added zoom level state



  // user header data
  const [fetchedUser, setFetchedUser] = useState(null); // State to hold fetched user data
  const { id: followeeId } = useParams();
  const handleFollow = async (followeeId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${apiBaseUrl.replace('/api/markers', '')}users/follow/${followeeId}`, {}, {
        // await axios.post(`${apiBaseUrl}users/follow/${followeeId}`, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(response.data);
      alert('User followed successfully!');
    } catch (error) {
      console.error('Error following user:', error);
      alert('Error following user.');
    }
  };
  useEffect(() => {
    console.log(' ##### userpage_v2 #####')
    const fetchUser = async () => {
      setLoading(true); // Assuming loading state is shared or add a new one
      setError(null); // Assuming error state is shared or add a new one

      const token = localStorage.getItem('token'); // Get token

      try {
        // Assuming the API endpoint for fetching a single user is /api/users/:id
        const response = await axios.get(`${apiBaseUrl.replace('/api/markers/', '/users/')}${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setFetchedUser(response.data); // Set the fetched user data
        console.log("########### response.data data ######### ");
        console.log(response.data);
        console.log("########### fetched user data ######### ");
        console.log(fetchedUser)
      } catch (error) {
        // Handle errors, e.g., user not found
        console.error('Error fetching user data:', error);
        // Optionally set an error state or redirect
        if (error.response && error.response.status === 401) {
          setError('Hãy đăng nhập để xem thông tin người dùng');
        } else if (error.response && error.response.status === 404) {
          setError('Không tìm thấy người dùng này');
        } else {
          setError('Lỗi khi tải thông tin người dùng');
        }
        setFetchedUser(null); // Clear user data on error
      } finally {
        setLoading(false); // Assuming loading state is shared
      }
    };

    if (id) { // Only fetch if id is available
      fetchUser();
    }
  }, [id, apiBaseUrl]); // Re-run when id or apiBaseUrl changes




  const videoRef = useRef(null);

  const handleSlideClick = (file) => {
    // setActiveProperty({file: file});
    setActiveProperty(file);
    setShowPopup(true);
  };

  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--dvh', `${vh}px`);
    };

    setVH(); // Set on load
    window.addEventListener('resize', setVH);
    return () => window.removeEventListener('resize', setVH);
  }, []);

  // Placeholder functions - Implement logic as needed
  const toggleFilter = () => setFilterIsVisible(!filterIsVisible);
  const clearFilter = () => { console.log("Clear filter clicked"); };
  const handleFilterChange = (event) => { console.log("Filter changed:", event.target.value); };
  const handleCartItemClick = (property) => { console.log("Card clicked:", property); };

  // Fetch markers from the API
  const oldfetchMarkers = async () => {
    setLoading(true);
    setError(null);

    // Retrieve token from localStorage
    const token = localStorage.getItem('token');

    try {
      const response = await axios.get(apiBaseUrl + 'own', {
        headers: {
          Authorization: `Bearer ${token}`, // Add token to the Authorization header
        },
      });

      const fetchedMarkers = response.data;
      setMarkers(fetchedMarkers); // Update the state with fetched markers
      setPropertiesList(fetchedMarkers); // Initialize propertiesList with fetched markers
    } catch (error) {
      // setError('Error fetching markers');
      // console.error('Error fetching markers:', error);
      // Check if the error is due to 401 Unauthorized
      if (error.response && error.response.status === 401) {
        setError('Hãy đăng nhập');
        // Optionally, you can redirect to the login page here
        // window.location.href = '/login'; // Uncomment this line if you want to redirect
      } else {
        setError('Error fetching markers');
      }
      console.error('Error fetching markers:', error);

    } finally {
      setLoading(false);
    }
  };



  // 1) dynamically inject the Nunito font once
  // useEffect(() => {
  //   const link = document.createElement('link');
  //   link.href =
  //     'https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700&display=swap';
  //   link.rel = 'stylesheet';
  //   document.head.appendChild(link);
  // }, []);

  // helper to show a styled <p> with optional position overrides
  const privatefetchMarkers = async () => {
    setLoading(true);
    setError(null);

    const token = localStorage.getItem('token');

    try {
      const response = await axios.get(`${apiBaseUrl}own`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const fetchedMarkers = response.data;
      setMarkers(fetchedMarkers);
      setPropertiesList(fetchedMarkers);
    } catch (err) {
      const style = {
        fontFamily: "'Nunito', sans-serif",
        // fontSize: "1rem",
        fontWeight: 900,
        // color: "#d32f2f",
        // textAlign: "left",
        // right: "-100% !important",             // shifts the box 10% from the left edge
        // top: "-0px",             // adjust as needed

        margin: "1em 2",
        fontFamily: "'Nunito', sans-serif",
        fontSize: "20px",
        // textShadow: "-1px -1px 2px rgba(255,255,255,0.8),  1px 1px 2px rgba(0,0,0,0.3)", // shadow top left and bottom right
        textShadow: "0px 0px 2px rgba(0,0,0,0.8)",
      };

      if (err.response?.status === 401) {
        setError(
          <p style={style}>
            Hãy đăng nhập
          </p>
        );
      } else {
        setError(
          <p style={style}>
            Error fetching markers
          </p>
        );
      }

      console.error("Error fetching markers:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchMarkers = async () => {
    setLoading(true);
    setError(null);

    // Retrieve token from localStorage
    const token = localStorage.getItem('token');

    try {
      // Include the token in the Authorization header for the API request
      // const response = await axios.get(`${config.getAllURL}users/${id}`);
      const response = await axios.get(`${apiBaseUrl}publicview/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Add token to the Authorization header
        },
      });

      // setPlaces(response.data)
      console.log("########### fetch response App.js ######### ");
      console.log(response.data);
      setMarkers(response.data);  // Update the state with fetched markers
    } catch (error) {
      setError('Error fetching markers');
      console.error('Error fetching markers:', error);
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    fetchMarkers(); // Fetch markers when component mounts
    console.log('##### markers ######')
    console.log(markers)
  }, []);

  // Pointer event handlers for drag (better cross-device support)
  const handlePointerDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    isDragging.current = true;
    dragStartY.current = e.clientY;
    dragStartHeight.current = expandedHeight;
    e.target.setPointerCapture(e.pointerId);
    console.log('=== POINTER DOWN ===', { y: e.clientY, height: expandedHeight });

    // Disable transition during drag
    if (drawerRef.current) drawerRef.current.style.transition = 'none';
    if (mapRef.current) mapRef.current.style.transition = 'none';
  };

  const handlePointerMove = (e) => {
    if (!isDragging.current) return;
    e.preventDefault();
    e.stopPropagation();

    // Calculate delta in pixels, then convert to vh for 1:1 tracking
    const deltaY = dragStartY.current - e.clientY; // positive when dragging up
    const deltaVh = (deltaY / window.innerHeight) * 100;
    const newHeight = Math.min(100, Math.max(0, dragStartHeight.current + deltaVh));

    // Direct DOM manipulation for performance
    if (drawerRef.current) {
      drawerRef.current.style.height = `${newHeight}dvh`;
    }
    if (mapRef.current) {
      // Map height logic: calc(100dvh - ${expandedHeight}dvh + 14dvh)
      // Simply: 114 - newHeight
      const mapHeight = 114 - newHeight;
      mapRef.current.style.height = `${mapHeight}dvh`;
    }
  };

  const handlePointerUp = (e) => {
    if (!isDragging.current) return;
    isDragging.current = false;
    e.target.releasePointerCapture(e.pointerId);

    // Calculate final height based on where the drag ended relative to start
    const deltaY = dragStartY.current - e.clientY;
    const deltaVh = (deltaY / window.innerHeight) * 100;
    let finalRawHeight = Math.min(100, Math.max(0, dragStartHeight.current + deltaVh));

    console.log('=== POINTER UP ===', { rawHeight: finalRawHeight });

    // Snap logic
    let snappedHeight;
    if (finalRawHeight > 75) {
      console.log('Snapping to 100%');
      snappedHeight = 100;
    } else if (finalRawHeight > 40) {
      console.log('Snapping to 50%');
      snappedHeight = 50;
    } else {
      console.log('Snapping to 30%');
      snappedHeight = 30;
    }

    // Re-enable transition for smooth snap
    if (drawerRef.current) drawerRef.current.style.transition = 'height 0.3s ease-out';
    if (mapRef.current) mapRef.current.style.transition = 'height 0.3s ease-out';

    // Update state to trigger re-render and ensure consistency
    setExpandedHeight(snappedHeight);

    // Also explicitly set the styles to the snapped values immediately
    if (drawerRef.current) {
      drawerRef.current.style.height = `${snappedHeight}dvh`;
    }
    if (mapRef.current) {
      mapRef.current.style.height = `${114 - snappedHeight}dvh`;
    }
  };

  // Toggle between showing text or not on click
  const handleToggleText = (id) => {
    setMarkers((prevMarkers) => {
      return prevMarkers.map((marker) => {
        if (marker._id === id) {
          return {
            ...marker,
            showText: !marker.showText, // Toggle text visibility
          };
        }
        return marker;
      });
    });
  };

  return (
    <AppContainer>
      <Header />
      <div className="app"
        style={{
          height: "100dvh",//"100vh",  
          width: "100%",
          // position: "relative",
          position: "absolute",
          top: '0px',
          overflowY: "hidden",
          overflowX: "hidden",
        }}>

        {/* Google Map Container with Ref */}
        <div
          ref={mapRef}
          style={{
            position: "absolute",
            top: "-12%",
            left: "-45%",
            width: "150%",
            height: `calc(100dvh - ${expandedHeight}dvh + 14dvh )`,
            // Initial inline style matches the state
            transition: 'height 0.3s ease-out'
          }}
        >
          <GoogleMapReact
            // bootstrapURLKeys={{ key: "AIzaSyDfnY7GcBdHHFQTxRCSJGR-AGUEUnMBfqo" }} // Ensure your API key is valid

            bootstrapURLKeys={{ key: "" }} // Ensure your API key is valid

            defaultCenter={defaultProps.center}
            defaultZoom={defaultProps.zoom}
            yesIWantToUseGoogleMapApiInternals
            options={{
              gestureHandling: 'greedy',
            }}
            style={{
              width: '100%',
              height: '100%',
              position: 'relative', // Relative to the wrapper
              margin: 0,
              padding: 0
            }}
          >
            {loading ? (
              <p>Loading markers...</p>
            ) : error ? (
              <p
                style={{
                  color: '#fefefe',        // Red color for the error text
                  fontSize: '15px',    // Increase the font size
                  textAlign: 'left', // Center-align the text
                  marginLeft: '0px',
                  // padding: '20px',     // Add padding around the text
                  // backgroundColor: 'rgba(255, 0, 0, 0.1)', // Light red background
                  // borderRadius: '8px', // Rounded corners
                  // maxWidth: '80%',     // Max width for better responsiveness
                  // margin: '20px auto', // Center the error box horizontally
                  // fontWeight: 'bold'   // Make the text bold
                }}
              >
                {error}
              </p>
            ) : (
              markers.map((marker) => (
                <Marker
                  key={marker._id} // Ensure each marker has a unique key
                  lat={marker.location.coordinates[0]} // Latitude at index 0
                  lng={marker.location.coordinates[1]} // Longitude at index 1
                  text={marker.title} // Title of the marker
                />
              ))
            )}
          </GoogleMapReact>
        </div>

        {/* <UserPagePreview/> */}
        <UserPagePreview
          drawerRef={drawerRef} // Pass the ref
          onPointerDown={handlePointerDown}
          onPointerMove={handlePointerMove}
          onPointerUp={handlePointerUp}
          expandedHeight={expandedHeight}
          markers={markers}
          activeProperty={activeProperty}
          setActiveProperty={setActiveProperty}
          showPopup={showPopup}
          setShowPopup={setShowPopup}
        />

      </div>
    </AppContainer>
  );
};



// Mock environment variables and hooks for standalone preview
// const useParams = () => ({id: 'mockUserId123'})
// const apiBaseUrl = 'https://mockapi.com/api/markers/' // Mock API base URL

// --- ICON Definitions (Replaced Lucide Icons with Inline SVG) ---

const Icon = ({
  name,
  size = 24,
  color = 'currentColor',
  onClick,
  fill = 'none',
  className = '',
}) => {
  // Corrected the SVG definitions to ensure proper JSX structure, especially for multi-element icons.
  const icons = {
    ChevronLeft: <path d="M15 18l-6-6 6-6" />,
    User: (
      <>
        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </>
    ),
    Mail: (
      <>
        <rect width="20" height="16" x="2" y="4" rx="2" />
        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
      </>
    ),
    CheckCircle: (
      <>
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <path d="m9 11 3 3 8-8" />
      </>
    ),
    Grid: (
      <>
        <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
        <line x1="3" x2="21" y1="9" y2="9" />
        <line x1="3" x2="21" y1="15" y2="15" />
        <line x1="9" x2="9" y1="3" y2="21" />
        <line x1="15" x2="15" y1="3" y2="21" />
      </>
    ),
    Square: <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />,
    List: (
      <>
        <line x1="8" x2="21" y1="6" y2="6" />
        <line x1="8" x2="21" y1="12" y2="12" />
        <line x1="8" x2="21" y1="18" y2="18" />
        <line x1="3" x2="3.01" y1="6" y2="6" />
        <line x1="3" x2="3.01" y1="12" y2="12" />
        <line x1="3" x2="3.01" y1="18" y2="18" />
      </>
    ),
    Home: (
      <>
        <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </>
    ),
    Search: (
      <>
        <circle cx="11" cy="11" r="8" />
        <line x1="21" x2="16.65" y1="21" y2="16.65" />
      </>
    ),
    PlusSquare: (
      <>
        <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
        <line x1="12" x2="12" y1="8" y2="16" />
        <line x1="8" x2="16" y1="12" y2="12" />
      </>
    ),
    Heart: (
      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
    ),
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`icon ${className}`}
      onClick={onClick}
    >
      {icons[name]}
    </svg>
  )
}

// Utility for fetching the user (Real API implementation)
// Utility for fetching the user (Real API implementation)
const useUserLogic = (id) => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [fetchedUser, setFetchedUser] = useState(null)
  const [isFollowing, setIsFollowing] = useState(false); // Add isFollowing state

  useEffect(() => {
    const fetchUserAndStatus = async () => {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem('token');

      try {
        // Fetch user data from API
        const userResponse = await axios.get(`${apiBaseUrl.replace('/api/markers/', '/users/')}${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setFetchedUser(userResponse.data);
        console.log("########### Fetched user data ######### ", userResponse.data);

        // Fetch follow status
        if (token) {
          try {
            const followResponse = await axios.get(`${apiBaseUrl.replace('/api/markers/', '/users/isfollowing/')}${id}`, {
              headers: { Authorization: `Bearer ${token}` }
            });
            setIsFollowing(followResponse.data.isFollowing);
            console.log("Follow status:", followResponse.data.isFollowing);
          } catch (followError) {
            console.error("Error checking follow status:", followError);
            // Don't fail the whole page load if just follow status fails, but maybe log it
          }
        }

      } catch (error) {
        console.error('Error fetching user data:', error);
        if (error.response && error.response.status === 401) {
          setError('Hãy đăng nhập để xem thông tin người dùng');
        } else if (error.response && error.response.status === 404) {
          setError('Không tìm thấy người dùng này');
        } else {
          setError('Lỗi khi tải thông tin người dùng');
        }
        setFetchedUser(null);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchUserAndStatus();
    }
  }, [id]);

  const handleToggleFollow = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      alert("Please login to follow users.");
      return;
    }

    // Optimistic update
    const previousState = isFollowing;
    setIsFollowing(!previousState);

    // Optimistically update follower count
    setFetchedUser(prev => {
      if (!prev) return prev;
      // Robustly handle user structure for update
      const user = prev.user || prev;
      const currentCount = parseInt(user.followersCount || 0);
      const newCount = !previousState ? currentCount + 1 : Math.max(0, currentCount - 1);

      if (prev.user) {
        return { ...prev, user: { ...prev.user, followersCount: newCount } };
      } else {
        return { ...prev, followersCount: newCount };
      }
    });

    try {
      if (previousState) {
        // Was following, so unfollow
        await axios.delete(`${apiBaseUrl.replace('/api/markers/', '/users/unfollow/')}${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        console.log("Unfollowed successfully");
      } else {
        // Was not following, so follow
        await axios.post(`${apiBaseUrl.replace('/api/markers/', '/users/follow/')}${id}`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
        console.log("Followed successfully");
      }
    } catch (error) {
      console.error("Error toggling follow:", error);
      // Revert optimistic update on error
      setIsFollowing(previousState);
      alert("Failed to update follow status.");
    }
  };

  return { fetchedUser, loading, error, isFollowing, handleToggleFollow }
}

// Real function for handleFollow (API implementation)
// Real function for handleFollow (API implementation)
// LEAVE EMPTY or REMOVE - functionality moved to useUserLogic hook
// const handleFollowUser = async (followeeId) => { ... }

// --- Utility Components ---

/**
 * StatItem component for displaying post, follower, or following counts.
 */
const StatItem = ({ count, label }) => (
  <div className="stat-item">
    <span className="stat-count">{count}</span>
    <span className="stat-label">{label}</span>
  </div>
)

/**
 * HighlightBubble component for the horizontal scrollable stories/highlights.
 */
const HighlightBubble = ({ name }) => (
  <div className="highlight-bubble">
    <div className="highlight-circle shimmer-bg" />
    <span className="highlight-name">{name}</span>
  </div>
)

// --- Profile Screen Sections ---

/**
 * Custom Header component for navigation and screen title
 * MODIFIED: Removed back button and title
 */
const ProfileHeader = () => (
  <header className="profile-header">
    {/* Placeholder for potential future icons (e.g., settings, share) */}
    <div className="header-spacer"></div>
  </header>
)

/**
 * ProfileStats component contains the profile picture, stats, and action buttons.
 */
const ProfileStats = ({ data, handleFollow, followeeId, isFollowing }) => {
  // Robustly handle data structure (could be data.user or just data)
  const user = data?.user || data || {};

  // Debug log
  // console.log("ProfileStats user data:", user);

  const postsCount = user.postsCount || '0'
  const followersCount = user.followersCount || '0'
  const followingCount = user.followingCount || '0'
  const profilePicture = user.profilePicture || 'https://obj.tang17so82duytan.com/demo-map/default-icon.png'

  return (
    <section className="profile-stats-section">
      {/* Profile Picture */}
      <div className="profile-pic-container">
        <img
          src={profilePicture}
          alt="Profile"
          className="profile-pic-img"
          style={{
            objectFit: 'cover',
            objectPosition: 'center'
          }}
        />
      </div>

      {/* Stats and Action Buttons */}
      <div className="profile-info-actions">
        {/* Stats Row */}
        <div className="stats-row">
          <StatItem count={postsCount} label="Posts" />
          <StatItem count={followersCount} label="Followers" />
          <StatItem count={followingCount} label="Following" />
        </div>

        {/* Action Buttons Row */}
        <div className="action-buttons-row">
          {/* Follow Button */}
          <button
            className="follow-button"
            onClick={handleFollow}
            style={{
              backgroundColor: isFollowing ? '#E5E7EB' : '#2563EB',
              color: isFollowing ? '#374151' : 'white'
            }}
          >
            <span
              style={{
                fontFamily: "'Nunito', sans-serif",
                webkitTextStroke: '0.6px',
                // fontSize: '0.8rem',
              }}
            >{isFollowing ? "FOLLOWING" : "FOLLOW"}</span>
            {!isFollowing && <Icon name="User" size={16} color="white" />}
          </button>

          {/* Message Button */}
          <button
            className="message-button"
            onClick={() => console.log('Message button clicked')}
          >
            <Icon name="Mail" size={16} color="#4B5563" />
          </button>
        </div>
      </div>
    </section>
  )
}

/**
 * Bio component displays the user's name, verification status, and description.
 */
const Bio = ({ data }) => {
  const name = data?.user?.name || data?.user?.username || ''
  const description = data?.user?.description || 'No bio available.'
  const isVerified = data?.user?.isVerified

  return (
    <section className="bio-section">
      <div className="bio-name-row">
        <div className="bio-name">{name}</div>
        {isVerified && (
          <Icon
            name="CheckCircle"
            size={20}
            color="#3B82F6"
            fill="#3B82F6"
            className="verified-icon"
          />
        )}
      </div>
      <div className="bio-description">{description}</div>
    </section>
  )
}

/**
 * Highlights component renders the horizontal scrollable list.
 */
const Highlights = ({ highlights }) => (
  <section className="highlights-section">
    <div className="highlights-list scrollbar-hide">
      {highlights.map((name) => (
        <HighlightBubble key={name} name={name} />
      ))}
    </div>
  </section>
)

/**
 * PostGrid component displays the main grid of user content.
 */
const PostGrid = ({
  setActiveTab,
  activeTab,
  onPointerDown,
  onPointerMove,
  onPointerUp,
  markers = [],
  setActiveProperty,
  setShowPopup,
  loading = false,
}) => {
  return (
    <section className="post-grid-section">
      {/* Tab Bar */}
      <div
        className="tab-bar"
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
      >
        {['posts', 'reels', 'saved'].map((tabName) => (
          <div
            key={tabName}
            className={`tab-item ${activeTab === tabName ? 'tab-active' : ''}`}
            onClick={() => setActiveTab(tabName)}
          >
            <Icon
              name={
                tabName === 'posts'
                  ? 'Grid'
                  : tabName === 'reels'
                    ? 'Square'
                    : 'List'
              }
              size={24}
              color={activeTab === tabName ? '#2563EB' : '#9CA3AF'}
            />
          </div>
        ))}
      </div>

      {/* Grid Content or Empty State */}
      <div className="grid-content-wrapper">
        {activeTab === 'posts' && (
          <div className="post-grid">
            {loading ? (
              // Show shimmer animation while loading
              Array.from({ length: 12 }).map((_, index) => (
                <div key={index} className="post-grid-item shimmer-bg" />
              ))
            ) : (
              // Display all markers, show camera icon for those without images
              markers.map((marker) => {
                const media = marker.media;
                const title = marker.title || '';
                const hasMedia = media?.[0]?.url;

                return (
                  <div
                    key={marker._id}
                    className="post-grid-item"
                    onClick={() => {
                      setActiveProperty(marker);
                      setShowPopup(true);
                    }}
                    style={{
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      overflow: 'hidden',
                      backgroundColor: '#f3f4f6',
                      position: 'relative'
                    }}
                  >
                    {hasMedia ? (
                      media[0].url.endsWith('.mp4') ? (
                        <div className="card-image" style={{ width: '100%', height: '100%' }}>
                          <img
                            src={media[0].thumbnailUrl ? `https://${media[0].thumbnailUrl}` : 'https://via.placeholder.com/150'}
                            alt={title}
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                          />
                        </div>
                      ) : (
                        <div className="card-image" style={{ width: '100%', height: '100%' }}>
                          <img
                            src={`https://${media[0].url}`}
                            alt={title}
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                          />
                        </div>
                      )
                    ) : (
                      <svg
                        width="48"
                        height="48"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#9ca3af"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                        <circle cx="12" cy="13" r="4"></circle>
                      </svg>
                    )}
                  </div>
                );
              })
            )}
          </div>
        )
        }
        {
          activeTab !== 'posts' && (
            <div className="empty-state">
              {activeTab.charAt(0).toUpperCase() + activeTab.slice(1)} content
              coming soon...
            </div>
          )
        }
      </div>

    </section>
  )
}

/**
 * Fixed Bottom Navigation (Footer)
      */
const FooterNav = () => (
  <footer className="footer-nav">
    <div className="footer-links">
      <Icon name="Home" size={24} color="#6B7280" className="cursor-pointer" />
      <Icon
        name="Search"
        size={24}
        color="#6B7280"
        className="cursor-pointer"
      />
      <Icon
        name="PlusSquare"
        size={24}
        color="#6B7280"
        className="cursor-pointer"
      />
      <Icon name="Heart" size={24} color="#6B7280" className="cursor-pointer" />
      <Icon name="User" size={24} color="#2563EB" className="cursor-pointer" />
    </div>
  </footer>
)

// const UserPagePreview = () => {
const UserPagePreview = ({
  drawerRef, // Receive ref
  onPointerDown,
  onPointerMove,
  onPointerUp,
  expandedHeight,
  markers = [], // Add markers prop
  activeProperty,
  setActiveProperty,
  showPopup,
  setShowPopup,
}) => {
  const { id } = useParams()
  // const { fetchedUser, loading, error } = useFetchUser(id)
  const { fetchedUser, loading, error, isFollowing, handleToggleFollow } = useUserLogic(id)
  const [activeTab, setActiveTab] = useState('posts')

  // Ref for scrollable content to preserve scroll position
  const scrollContentRef = useRef(null)
  const scrollPositionRef = useRef(0)

  // Preserve scroll position when popup opens/closes
  useEffect(() => {
    // Only restore when popup closes
    if (!showPopup) {
      // Restore scroll position when popup closes
      console.log('Restoring scrollTop. Saved value:', scrollPositionRef.current);
      if (scrollContentRef.current && scrollPositionRef.current > 0) {
        // Use setTimeout to ensure DOM has updated
        setTimeout(() => {
          if (scrollContentRef.current) {
            console.log('Applying scrollTop:', scrollPositionRef.current);
            scrollContentRef.current.scrollTop = scrollPositionRef.current
          }
        }, 0)
      } else {
        console.log('Not restoring. Ref null or saved value 0');
      }
    }
  }, [showPopup])

  // Mock highlights data
  const mockHighlights = [
    'Dubai',
    'Thailand',
    'Berlin',
    'Asia',
    'London',
    'New York',
  ]

  // Use id from useParams as followeeId
  const followeeId = id

  const username = fetchedUser?.user?.username || 'loading...'

  // Mock for AppContainer2
  const AppContainer2 = ({ children }) => (
    <div className="app-container">{children}</div>
  )

  // --- RENDER FUNCTION ---
  return (
    <AppContainer2>
      {/* Mock Message Box for non-alert feedback */}
      <div id="mock-message-box" className="mock-message-box"></div>

      <style>
        {`
                    /* General Setup */
                    body {
                        font-family: 'Inter', sans-serif;
                        margin: 0;
                        background-color: #F3F4F6; /* bg-gray-100 */
                    }
                    .app-container {
                        min-height: 100vh;
                        width: 100vw;
                        display: flex;
                        justify-content: center;
                        // padding: 1rem; /* p-4 */
                    }
                    .profile-screen-wrapper {
                        width: 100%;
                        // height: 100vh; //HERE**
                        // height: ${expandedHeight}dvh;
                        max-width: 384px; /* max-w-sm */
                        background-color: white;
                        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04); /* shadow-xl */
                        border-radius: 1rem; /* rounded-2xl */
                        display: flex;
                        flex-direction: column;
                        position: absolute;
                        bottom: 0;
                        // min-height: 800px; /* Ensure sufficient height for preview */
                        overflow: hidden; /* Important for the rounded corners */
                    }
                    .scrollable-content {
                        flex-grow: 1;
                        display: flex;
                        flex-direction: column;
                        overflow-y: scroll;
                    }
                    
                    /* Shimmer Animation */
                    @keyframes shimmer {
                        0% { background-position: -600% 0; }
                        100% { background-position: 600% 0; }
                    }
                    .shimmer-bg {
                        background-image: linear-gradient(to right, #E5E7EB 0%, #D1D5DB 20%, #E5E7EB 40%, #E5E7EB 100%);
                        background-size: 600% 100%;
                        animation: shimmer 15s infinite linear; 
                    }
                    /* Hide scrollbar */
                    .scrollbar-hide {
                        -ms-overflow-style: none;
                        scrollbar-width: none;
                    }
                    .scrollbar-hide::-webkit-scrollbar {
                        display: none;
                    }

                    /* --- Header --- */
                    /* MODIFIED: Header is now just a placeholder for padding/structure */
                    .profile-header {
                        display: flex;
                        align-items: center;
                        justify-content: flex-end; /* Align spacer to the right for balance */
                        padding: 1rem; /* p-4 */
                        background-color: white;
                        border-bottom: 1px solid #F3F4F6; 
                        /* border-b border-gray-100 */
                        position: sticky;
                        top: 0;
                        z-index: 10;
                        height: 2.5rem; /* Ensure minimal height for the sticky bar */
                    }
                    /* Removed .header-back, .header-title, .header-back-text styles */
                    .header-spacer {
                        /* Used as a minimal flex item to maintain structure/padding */
                        width: 1rem; 
                    }

                    /* --- Profile Stats --- */
                    .profile-stats-section {
                        display: flex;
                        padding: .2rem 1rem;; /* p-4 */
                        
                        background-color: white;
                    }
                    .profile-pic-container {
                        width: 6rem; /* w-24 */
                        height: 6rem; /* h-24 */
                        margin-top: 1rem; /* mt-4 */
                        border-radius: 9999px; /* rounded-full */
                        flex-shrink: 0;
                        margin-right: 1rem; /* mr-4 */
                        background-color: #E5E7EB; /* Default grey background */
                        overflow: hidden;
                    }
                    .profile-pic-img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .profile-info-actions {
                        display: flex;
                        flex-direction: column;
                        flex-grow: 1;
                        justify-content: flex-end;
                        gap: 0.25rem; /* space-y-1 */
                        margin-top: -2rem; /* -mt-8 to pull content up */
                    }
                    .stats-row {
                        display: flex;
                        justify-content: space-evenly;
                        gap: 1rem; /* gap-8 */
                        padding-bottom: 0.1rem; /* Add this line */

                    }
                    .stat-item {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }
                    .stat-item:first-child {
                        margin-right: 0.5rem; /* Extra space after Posts */
                    }
                    .stat-count {
                        font-size: 0.875rem; /* text-sm */
                        font-weight: 700; /* font-bold */
                        color: #1F2937; /* text-gray-800 */

                        -webkit-text-stroke: .6px;
                        font-size: 0.8rem;
                        // color: rgb(140, 140, 140);                        

                    }
                    .stat-label {
                        font-size: 0.75rem; /* text-xs */
                        color: #6B7280; /* text-gray-500 */
                        margin-top: -0.25rem; /* -mt-1 */

                        -webkit-text-stroke: .4px;
                        // font-size: 0.8rem;
                        color: rgb(150, 150, 150);                        
                    }

                    /* Action Buttons */
                    .action-buttons-row {
                        display: flex;
                        gap: 0.5rem; /* space-x-2 */
                    }
                    .follow-button {
                        flex: 1;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 0.25rem; /* space-x-1 */
                        background-color: #2563EB; /* bg-blue-600 */
                        color: white;
                        font-size: 0.875rem; /* text-sm */
                        font-weight: 600; /* font-semibold */
                        padding: 0.375rem 0.75rem; /* py-1.5 px-3 */
                        border-radius: 0.5rem; /* rounded-lg */
                        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.06); /* shadow-md */
                        transition: background-color 0.15s, transform 0.15s;
                        border: none;
                        cursor: pointer;
                    }
                    .follow-button:hover {
                        background-color: #1D4ED8; /* hover:bg-blue-700 */
                    }
                    .follow-button:active {
                        transform: scale(0.95);
                    }

                    .message-button {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background-color: white;
                        border: 1px solid #D1D5DB; /* border border-gray-300 */
                        color: #1F2937; /* text-gray-800 */
                        padding: 0.5rem; /* p-2 */
                        border-radius: 0.5rem; /* rounded-lg */
                        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06); /* shadow-sm */
                        transition: background-color 0.15s, transform 0.15s;
                        cursor: pointer;
                    }
                    .message-button:hover {
                        background-color: #F9FAFB; /* hover:bg-gray-50 */
                    }
                    .message-button:active {
                        transform: scale(0.95);
                    }

                    /* --- Bio --- */
                    .bio-section {
                        padding: 0.5rem 1rem; /* px-4 py-2 */
                        background-color: white;
                    }
                    .bio-name-row {
                        display: flex;
                        align-items: center;
                        margin-bottom: 0.25rem; /* mb-1 */
                    }
                    .bio-name {
                        font-size: 1.125rem; /* text-lg */
                        font-weight: 700; /* font-bold */
                        color: #111827; /* text-gray-900 */
                        margin-right: 0.5rem; /* mr-2 */
                    }
                    .verified-icon {
                        margin-top: -2px; /* slight adjustment */
                        fill: #3B82F6;
                    }
                    .bio-description {
                        -webkit-text-stroke: .4px;
                        font-size: 0.8rem;
                        color: rgb(140, 140, 140);

                    }

                    /* --- Highlights --- */
                    .highlights-section {
                        /* Removed padding to avoid the "white wall" effect on scroll */
                        padding-top: .5rem;
                        padding-bottom: 0.8rem;
                        background-color: white;
                        // border-bottom: 1px solid #F3F4F6; 
                        /* border-b border-gray-100 */
                    }
                    .highlights-list {
                        display: flex;
                        gap: 0.5rem; /* space-x-2 */
                        overflow-x: scroll;
                        /* Add padding here so content starts indented but scrolls to edge */
                        padding-left: 1rem;
                        padding-right: 1rem;
                    }
                    .highlight-bubble {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        width: 4rem; /* w-16 */
                        flex-shrink: 0;
                    }
                    .highlight-circle {
                        width: 4rem; /* w-16 */
                        height: 4rem; /* h-16 */
                        border-radius: 9999px; /* rounded-full */
                        border: 2px solid #E5E7EB; /* border-2 border-gray-200 */
                        margin-bottom: 0.25rem; /* mb-1 */
                    }
                    .highlight-name {
                        font-size: 0.75rem; /* text-xs */
                        font-weight: 500; /* font-medium */
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        width: 100%;
                        text-align: center;
                        -webkit-text-stroke: .6px;
                        font-size: 0.8rem;
                        color: rgb(140, 140, 140);

                    }

                    /* --- Post Grid & Tabs --- */
                    .post-grid-section {
                        display: flex;
                        flex-direction: column;
                        flex-grow: 1;
                    }
                    .tab-bar {
                        display: flex;
                        justify-content: space-around;
                        // border-top: 1px solid #E5E7EB; 
                        /* border-t border-gray-200 */
                        background-color: white;
                        position: sticky;
                        // top: 0.9rem; 
                        /* Adjusted sticky position to account for the header's new size */
                        top: 14px; 
                        z-index: 5;
                    }
                    .tab-item {
                        padding: 0.75rem; /* p-3 */
                        cursor: pointer;
                        color: #9CA3AF; /* text-gray-400 */
                        transition: color 0.15s;
                    }
                    .tab-item:hover {
                        color: #4B5563; /* hover:text-gray-600 */
                    }
                    .tab-active {
                        border-bottom: 2px solid #2563EB; /* border-b-2 border-blue-600 */
                        color: #2563EB !important;
                    }

                    .grid-content-wrapper {
                        padding: 0.3rem; /* p-0.5 */
                        // background-color: #F9FAFB; /* bg-gray-50 */
                        flex-grow: 1;
                    }
                    .post-grid {
                        display: grid;
                        grid-template-columns: repeat(3, 1fr);
                        gap: 0.125rem; /* gap-0.5 */
                        min-height: 50vh;
                    }
                    .post-grid-item {
                        /* Aspect ratio of 3:4 (vertical) */
                        // padding-bottom: 133.33%; /* height = width * (4/3) */
                        aspect-ratio: 9 / 13;
                        position: relative;
                        width: 100%;
                        border-radius: 4px;
                        
                    }
                    .post-grid-item::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        // background-color: #D1D5DB; /* Fallback for shimmer */
                    }
                    .empty-state {
                        padding: 1rem;
                        text-align: center;
                        color: #6B7280;
                    }

                    /* --- Footer Nav --- */
                    .footer-nav {
                        position: absolute;
                        bottom: 0;
                        width: 100%;
                        background-color: white;
                        border-top: 1px solid #E5E7EB; /* border-t border-gray-200 */
                        z-index: 50;
                        border-bottom-left-radius: 1rem; /* rounded-b-2xl */
                        border-bottom-right-radius: 1rem;
                    }
                    .footer-links {
                        display: flex;
                        justify-content: space-around;
                        align-items: center;
                        height: 4rem; /* h-16 */
                    }

                    /* Mock Message Box */
                    .mock-message-box {
                        position: fixed;
                        top: 20px;
                        left: 50%;
                        transform: translateX(-50%);
                        background-color: #1F2937;
                        color: white;
                        padding: 10px 20px;
                        border-radius: 8px;
                        z-index: 1000;
                        opacity: 0;
                        transition: opacity 0.5s ease-in-out;
                        font-size: 0.875rem;
                        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
                        pointer-events: none;
                    }
                `}
      </style>

      {/* Profile Screen Container */}
      <div
        ref={drawerRef} // Attach ref here
        className="profile-screen-wrapper"
        style={{
          // position: "absolute",
          // top: "-12%",
          // left: "-45%",
          // width: "150%",
          // height: `calc(100dvh - ${expandedHeight}dvh + 14dvh )` // Map height adjusts with expanded area
          height: `${expandedHeight}dvh`
        }}
      >
        {/* Top Header - Now simplified */}
        {/* <ProfileHeader /> */}

        {/* Scrollable Content Area */}
        <div
          ref={scrollContentRef}
          className="scrollable-content"
          onScroll={(e) => {
            // Throttle logs to avoid spamming
            if (Math.random() > 0.95) {
              console.log("Scroll event on .scrollable-content. scrollTop:", e.target.scrollTop);
            }
          }}
          style={{
            // The height property is removed as it conflicts with flex-grow and parent's height
          }}

        >
          {loading ? (
            <>
              {/* Display loading components */}
              {/* <SwipeableBar/> */}
              <SwipeableBar
                onPointerDown={onPointerDown}
                onPointerMove={onPointerMove}
                onPointerUp={onPointerUp}
              />
              <ProfileStats
                data={{}}
                handleFollow={handleToggleFollow}
                followeeId={followeeId}
                isFollowing={isFollowing}
              />
              <Bio data={{}} />
              <Highlights highlights={mockHighlights} />
              <PostGrid
                setActiveTab={setActiveTab}
                activeTab={activeTab}
                onPointerDown={onPointerDown}
                onPointerMove={onPointerMove}
                onPointerUp={onPointerUp}
                markers={markers}
                setActiveProperty={setActiveProperty}
                setShowPopup={(value) => {
                  console.log("setShowPopup wrapper called with:", value);
                  // Capture scroll position before opening popup
                  if (value === true) {
                    if (scrollContentRef.current) {
                      scrollPositionRef.current = scrollContentRef.current.scrollTop;
                      console.log("Captured scroll before open. scrollTop:", scrollPositionRef.current);
                    } else {
                      console.log("CRITICAL: scrollContentRef.current is null in setShowPopup wrapper!");
                    }
                  }
                  setShowPopup(value);
                }}
                loading={true}
              />
              {/* Spacer */}
              <div style={{ height: '4rem', flexShrink: 0 }}></div>
            </>
          ) : error ? (
            <div
              className="empty-state"
              style={{ color: 'red', fontWeight: 'bold' }}
            >
              {error}
            </div>
          ) : (
            <>
              {/* Swipeable Horizontal Bar */}
              {/* <SwipeableBar/> */}
              <SwipeableBar
                onPointerDown={onPointerDown}
                onPointerMove={onPointerMove}
                onPointerUp={onPointerUp}
              />
              <ProfileStats
                data={fetchedUser}
                handleFollow={handleToggleFollow}
                followeeId={followeeId}
                isFollowing={isFollowing}
              />
              <Bio data={fetchedUser} />
              <Highlights highlights={mockHighlights} />
              <PostGrid
                setActiveTab={setActiveTab}
                activeTab={activeTab}
                onPointerDown={onPointerDown}
                onPointerMove={onPointerMove}
                onPointerUp={onPointerUp}
                markers={markers}
                setActiveProperty={setActiveProperty}
                setShowPopup={(value) => {
                  console.log("setShowPopup wrapper (else block) called with:", value);
                  if (value === true) {
                    if (scrollContentRef.current) {
                      scrollPositionRef.current = scrollContentRef.current.scrollTop;
                      console.log("Captured scroll before open (else block). scrollTop:", scrollPositionRef.current);
                    } else {
                      console.log("CRITICAL: scrollContentRef.current is null in setShowPopup wrapper (else block)!");
                    }
                  }
                  setShowPopup(value);
                }}
                loading={false}
              />
              {/* Spacer to prevent last row of posts being cut off by the fixed bottom footer */}
              <div style={{ height: '4rem', flexShrink: 0 }}></div>
            </>
          )}
        </div>

        {/* Fixed Footer */}
        {/* <FooterNav /> */}

        {/* Popup for marker details */}
        {showPopup && activeProperty && (
          <Popup
            property={activeProperty}
            setShowPopup={setShowPopup}
          />
        )}
      </div>
    </AppContainer2>
  )
}


const SwipeableBar = ({
  onPointerDown,
  onPointerMove,
  onPointerUp,
  style = {},
}) => {
  return (
    <div
      style={{
        position: 'sticky',
        top: '0px',
        left: '0',
        width: '100%',
        height: '15px', // Increased to 120px for easier drag
        backgroundColor: '#fefefe',
        cursor: 'grab',
        zIndex: 10002,
        paddingBottom: '2px',
        flexShrink: 0,
        touchAction: 'none', // Disable browser touch gestures
        ...style,
      }}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
    >
      <div
        style={{
          position: 'sticky',
          width: '50px',
          height: '4px',
          top: '60px', // Adjusted for new 120px height
          backgroundColor: '#A0A0A0',
          borderRadius: '10px',
          left: '50%',
          transform: 'translateX(-50%) translateY(-50%)',
        }}
      />
    </div>
  );
};




export default UserPage; // Updated export name
